import { Controller } from "@hotwired/stimulus";
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { gsap } from 'gsap';
import { Flip } from 'gsap/Flip';
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import getRect from "../../utilities/getRect";
import getElementProp from '../../utilities/getElementProp';
export default class extends Controller {
  static targets = ['container', 'linksContainer', 'links'];

  translateLength = -25;

  connect() {
    gsap.registerPlugin(Flip, ScrollToPlugin);

    const lazyImages = document.querySelectorAll('[loading="lazy"]');
    const bp = getElementProp(this.linksContainerTarget, '--share-bp');

    this.htmlElement = document.documentElement;
    this.bodyElement = document.querySelector('body');
    this.mainElement = document.querySelector('#main');
    this.shareButtonWidth = parseInt(getElementProp(this.containerTarget, '--share-icon-size'));
    this.shareContainerSize = parseInt(getElementProp(this.containerTarget, '--share-container-size'));

    this.state = Flip.getState(this.linksContainerTarget);
    this.useHorizontalLayout = window.matchMedia(`(min-width: ${bp})`).matches;
    this.isOpen = false;

    this.get_share_data();

    
    window.addEventListener('resize', e => {
      this.state = Flip.getState(this.linksContainerTarget);
    });

    lazyImages.forEach(img => {
      img.addEventListener('load', () => {
        this.state = Flip.getState(this.linksContainerTarget);
      })
    });
  }

  get_share_data() {
    this.url = window.location.href;
    this.title = this.linksContainerTarget.dataset.title.replaceAll('<br>', ' ');

    this.share_urls = {
      'facebook' : {
        'url' : 'https://www.facebook.com/sharer/sharer.php',
        'params' : {
          'u' : this.url
        }
      },
      'twitter' : {
        'url' : 'https://twitter.com/intent/tweet',
        'params' : {
          'url' : this.url,
          'text' : this.title
        }
      },
      'linkedin' : {
        'url' : 'https://www.linkedin.com/shareArticle',
        'params' : {
          'mini' : 'true',
          'url' : this.url,
          'title' : this.title
        }
      },
      'email' : {
        'url' : 'mailto:',
        'params' : {
          'body' : this.url,
          'subject' : this.title
        }
      }
    }
  }

  toggle(e) {
    if(this.isOpen) {
      this.close(e);
    }
    else {
      this.open(e);
    }

    this.isOpen = !this.isOpen;
  }

  open(e) {
    if(this.useHorizontalLayout) {
      e.target.classList.add('share-button-open');
      this.linksContainerTarget.style.width = `${this.shareContainerSize}px`;

      Flip.from(this.state, {
        duration: 0.5,
        ease: "power1.inOut",
        onComplete: this.showLinks.bind(this)
      });
    }
    else {
      //Addresses a quirk where the header angle appear above the modal area. This is a side-effect of how the parallax hero image is styled.
      this.mainElement.style.zIndex = 2;
      this.htmlElement.classList.add('u-scroll-behavior-auto');
      disableBodyScroll(this.containerTarget);
      this.containerTarget.classList.add('share-modal');
    }
  }

  close(e) {
    if(this.useHorizontalLayout) {
      e.target.classList.remove('share-button-open');
      const direction = this.useHorizontalLayout ? { x: this.translateLength } : { y: this.translateLength };

      gsap.to(this.linksTarget, { ...direction, opacity: 0, duration: 0.3, onComplete: () => {
        Flip.to(this.state, {
          duration: 0.3,
          ease: "power1.in"
        });
      }});
    }
  }

  closeModal() {
    this.mainElement.style = '';
    this.containerTarget.classList.remove('share-modal');

    this.isOpen = false;

    enableBodyScroll(this.containerTarget);

    gsap.delayedCall(0.2, () => {
      this.htmlElement.classList.remove('u-scroll-behavior-auto');
    }, []);
  }

  showLinks() {
    const directionFrom = this.useHorizontalLayout ? { x: this.translateLength } : { y: this.translateLength };
    const directionTo = this.useHorizontalLayout ? { x: 0 } : { y: 0 };

    gsap.fromTo(this.linksTarget, { ...directionFrom, opacity: 0 }, { ...directionTo, opacity: 1, stagger: 0.1 });
  }

  share(e) {
    const platform = e.target.dataset.platform;
    const share_url = this.share_urls[platform].url;
    const share_params = this.share_urls[platform].params;

    const share_query = Object.keys(share_params).map(key => key + '=' + share_params[key]).join('&');

    window.open(`${share_url}?${share_query}`);
  }

  copy() {
      navigator.clipboard.writeText(this.url)
          .then(() => {
            this.linksTarget.classList.add('-text-copied');
  
            gsap.delayedCall(1, () => {
              this.linksTarget.classList.remove('-text-copied');
            }, []);
      });
  }
}